// services/newsletterService.ts

import apiClient from "../../admin/api/apiClient";

const API_PATH = process.env.REACT_APP_API_PATH;

// ======================================
// INTERFACES
// ======================================

export interface NewsletterRequest {
  email: string;
  name?: string;
  source: string;
}

export interface NewsletterResponse {
  subscriberID: number;
  email: string;
  name: string;
  source: string;
  isActive: boolean;
  subscribedAt: string;
  unsubscribedAt: string | null;
}

export interface ApiResponse<T> {
  loggingHistoryID: number | null;
  statusCode: number;
  isSuccess: boolean;
  message: string;
  errors: string[] | null;
  data: T;
  dataList: T[];
}

// ======================================
// NEWSLETTER SERVICE
// ======================================

export const newsletterService = {

  

  // ======================================
  // CREATE
  // ======================================

  create: async (
    payload: NewsletterRequest
  ): Promise<ApiResponse<any>> => {

    const response =
      await apiClient.post<ApiResponse<any>>(
        `/Public/Newsletter`,
        payload
      );

    return response.data;
  },

  

  

}